import { formatDate, isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID, ɵDEFAULT_LOCALE_ID } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastService } from './Toast.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, firstValueFrom, forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError, debounceTime, filter, flatMap, map, mergeMap, switchMap } from 'rxjs/operators';
import { environment } from '../_environments/environment';
import { Shippingmethod } from '../_model/order';
import { BoxSubscription, BoxSubscriptionDelivery, Originentitytype, RecipeSubscription, RecipeSubscriptionDelivery, RecipeSubscriptionRecipeSelection, SubscriptionProductSelection, SubscriptionRepeatableproduct } from '../_model/subscription';
import { Frequency } from '../_model/weeks';
import { Snackbarerrorformat, Snackbarformat } from '../_theme/snackbarformats';
import { AuthService } from './AuthService';
import { CouponcodeService } from './CouponcodeService';
import { CustomerService } from './CustomerService';
import { DeliverydayService } from './DeliverydayService';
import { GlobalService } from './GlobalService';
import { WINDOW } from './WindowService';
import { SessionstorageService } from './SessionstorageService';
import { OrderService } from './OrderService';
import { Deliveryday } from 'src/_model/postalcodedelivery';
import { RecipeService } from './RecipeService';
import { Recipe } from 'src/_model/recipe';
import { ProductService } from './ProductService';
import { BoxService } from './BoxService';
import { Product } from 'src/_model/product';
import { Box } from 'src/_model/box';
import { PricingService } from './PricingService';
import { CustomerAddress } from 'src/_model/customer';

@Injectable({ providedIn: 'root' })
export class SubscriptionService {


  environment = environment;

  orderflowSubscriptionForm = this.initiateSubscription();

  private refreshTime: number = environment.dataRefreshTime;
  private subscriptions = this.fb.array([]);

  subscriptionsChanged = 0;

  public recipesubscriptionSubject: BehaviorSubject<RecipeSubscription[]> = new BehaviorSubject<RecipeSubscription[]>(null);
  recipesubscriptions: RecipeSubscription[] = [];
  recipesubscriptionsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public boxsubscriptionSubject: BehaviorSubject<BoxSubscription[]> = new BehaviorSubject<BoxSubscription[]>(null);
  boxsubscriptions: BoxSubscription[] = [];
  boxsubscriptionsError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private subscriptionRefreshTimer: any;

  hasSubscriptions = this.boxsubscriptions.length + this.recipesubscriptions.length > 0

  constructor(
    private fb: FormBuilder,
    private _http: HttpClient,
    private _deliverydayService: DeliverydayService,
    private _authService: AuthService,
    private _customerService: CustomerService,
    private _couponcodeService: CouponcodeService,
    private _orderService: OrderService,
    private _recipeService: RecipeService,
    private _productService: ProductService,
    private _boxService: BoxService,
    private _pricingService: PricingService,

    private _globalService: GlobalService,

    private _toastService: ToastService,

    private _translate: TranslateService,
    private _router: Router,
    private _sessionStorage: SessionstorageService,
    @Inject(WINDOW) private window: Window,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {

    this.subscriptions.valueChanges.subscribe(() => { this.subscriptionsChanged++; })

    this._authService.isAuthenticated$.pipe().subscribe( //skip(1)
      value => {
        if (!value) {
          this.subscriptions.clear();
          if (isPlatformBrowser(this.platformId))
            this.window.clearTimeout(this.subscriptionRefreshTimer);

          this.subscriptionsChanged = 0;

          this.recipesubscriptions = [];
          this.recipesubscriptionSubject.next(null);

          this.boxsubscriptions = [];
          this.boxsubscriptionSubject.next(null);

          this.orderflowSubscriptionForm.reset(this.initiateSubscription().value);
        } else {

          this.getCustomerRecipeSubscriptionList(_authService.getCurrentUser().customerid).subscribe();
          this.getCustomerBoxSubscriptionList(_authService.getCurrentUser().customerid).subscribe();

          //makes sure that the subscriptionform is cleared when the user logs in manually
          if (this._router.url.indexOf('personalmenu') == -1) { }

        }
      },
      () => {
        this.subscriptions.clear();
        this.orderflowSubscriptionForm = this.initiateSubscription();
        if (isPlatformBrowser(this.platformId))
          this.window.clearTimeout(this.subscriptionRefreshTimer);

        this.subscriptionsChanged = 0;

        this.recipesubscriptions = [];
        this.recipesubscriptionSubject.next(null);

        this.boxsubscriptions = [];
        this.boxsubscriptionSubject.next(null);

      },
      () => {
        this.subscriptions.clear();
        if (isPlatformBrowser(this.platformId))
          this.window.clearTimeout(this.subscriptionRefreshTimer);

        this.subscriptionsChanged = 0;

        this.recipesubscriptions = [];
        this.recipesubscriptionSubject.next(null);

        this.boxsubscriptions = [];
        this.boxsubscriptionSubject.next(null);

      });

    const SessionorderFlowForm = _sessionStorage.getObject('orderflowsubscriptionform');
    if (SessionorderFlowForm) {
      this.orderflowSubscriptionForm.patchValue(SessionorderFlowForm);
    }

    //sets elements to other elements so they updata automaticly
    this._globalService.replaceControl(this.orderflowSubscriptionForm, 'customerid', this._customerService.customerForm, 'id')
    this._globalService.setValueOnChanges(this.orderflowSubscriptionForm, 'pickupdeliverytimeframe', this._orderService.orderFlowForm)
    this._globalService.setValueOnChanges(this.orderflowSubscriptionForm, 'storeid', this._orderService.orderFlowForm)
    this._globalService.setValueOnChanges(this.orderflowSubscriptionForm, 'storetype', this._orderService.orderFlowForm)
    this._globalService.setValueOnChanges(this.orderflowSubscriptionForm, 'storedata', this._orderService.orderFlowForm, 'pickupstore')
    this._globalService.setValueOnChanges(this.orderflowSubscriptionForm, 'startdate', this._orderService.orderFlowForm, 'deliverydate')
    this._globalService.setValueOnChanges(this.orderflowSubscriptionForm, 'recipecard', this._orderService.orderFlowForm)
    this._globalService.setValueOnChanges(this.orderflowSubscriptionForm, 'shippingmethod', this._orderService.orderFlowForm)

    this.orderflowSubscriptionForm.valueChanges.subscribe({
      next: res => {
        this._sessionStorage.setObject('orderflowsubscriptionform', res)
      }
    })

    this._couponcodeService.couponcode$.pipe(filter(code => code !== null && (code.code !== null && code.code !== ''))).subscribe(couponcode => {
      this.setCouponcodeOnFirstAvailableSubscription(couponcode.code);
    })

  }

  get flowdefaultpersons(): FormControl {
    return this.orderflowSubscriptionForm.get('defaultpersons') as FormControl
  }
  get flowdefaultrecipes(): FormControl {
    return this.orderflowSubscriptionForm.get('defaultrecipes') as FormControl
  }

  private resetTimer() {
    if (isPlatformBrowser(this.platformId))
      this.window.clearTimeout(this.subscriptionRefreshTimer);
    this.subscriptionRefreshTimer = setTimeout(() => {
      console.log('executed subscription timeout', new Date());
      const user = this._authService.getCurrentUser();
      this.recipesubscriptions = [];
      this.boxsubscriptions = [];
      // this.subscriptions.clear();
      this.getCustomerRecipeSubscriptionList(user.customerid).subscribe();
      this.getCustomerBoxSubscriptionList(user.customerid).subscribe();
    }, this.refreshTime);
  }

  getCustomerRecipeSubscriptionList(customerid: number): Observable<RecipeSubscription[]> {
    if (!customerid) return of([])

    return this._http.get(environment.apiserver + 'recipesubscriptionbff/v1/recipesubscription/customerid/' + customerid).pipe(
      switchMap((response: RecipeSubscription[]) => {
        if (response.length > 0)
          return forkJoin(response.map(r => this.getCustomerRecipeSubscription(r.id)))  //EK-1354: Retrieves all subscriptions individually, to make sure it has all deliveries
        return of(response) //if none just return empty array
      }),
      map((response: RecipeSubscription[]) => {
        this.recipesubscriptionsError.next(false);
        response = response.sort((a, b) => a.id - b.id)

        //makes sure that a subscriptionid is set on the orderflowsubscriptionform if there isnt any yet
        //this is to overcome the possibility of creating multiple subscriptions
        if (response.length > 0 && !this.orderflowSubscriptionForm.get('id').value) {
          let sub: RecipeSubscription
          if (response.map(m => m.enabled).includes(true)) {
            sub = response.find(f => f.enabled)
          } else {
            sub = response[0]
          }
          this.orderflowSubscriptionForm.get('id').setValue(sub.id)
        }

        //sorts all products by id desc
        response.forEach(rec => {
          rec.recipeSubscriptionDeliveries.forEach(del => {
            if (del.recipeSubscriptionProductSelections)
              del.recipeSubscriptionProductSelections.sort((a, b) => b.id - a.id )
          })
        })
        //loads subscriptions into formarray
        this.loadSubscriptions(response, Originentitytype.RECIPE_SUBSCRIPTION);

        this.recipesubscriptions = response;
        this.recipesubscriptionSubject.next(response);
        this.resetTimer();

        return response;
      })
      , catchError(error => {
        this.recipesubscriptionsError.next(true);
        return this.handleError(error, 'subscription.get_subscriptionlist_error')
      })
    );
  }
  getCustomerRecipeSubscription(subscriptionid: number): Observable<RecipeSubscription> {
    /*return throwError(() => 'Server error');*/

    return this._http.get(environment.apiserver + 'recipesubscriptionbff/v1/recipesubscription/' + subscriptionid).pipe(
      map((response: RecipeSubscription) => {
        return response;
      })
      , catchError(error => this.handleError(error, 'subscription.get_subscription_error'))
    );
  }
  private updateRecipeSubscriptionWithLastdata(subscriptionForm: FormGroup, changedValues: any = null): Observable<RecipeSubscription> {
    if (subscriptionForm?.get('id').value > 0) {
      return this.getCustomerRecipeSubscription(subscriptionForm.get('id').value).pipe(
        switchMap((res: RecipeSubscription) => {
          if (!changedValues)
            changedValues = this._globalService.getDirtyValues(subscriptionForm);
          res = this._globalService.mergeDirtyValues(changedValues, res);
          //subscriptionForm.patchValue(res);
          return of(res);
        })
      );
    } else {
      return of(subscriptionForm.getRawValue());
    }
  }
  getCustomerRecipeSubscriptionDeliverydatesBySubscriptionid(subscriptionid: number): Observable<Deliveryday[]> {
    return this._deliverydayService.getRecipeSubscriptionDeliverydates(subscriptionid).pipe(
      map((response: Deliveryday[]) => <any>response),
      catchError(error => this.handleError(error, 'subscription.get_deliverydates_error'))
    );
  }
  saveRecipeSubscription(subscriptionForm: FormGroup, changedValues: any = null): Observable<RecipeSubscription> {

    return this.updateRecipeSubscriptionWithLastdata(subscriptionForm, changedValues).pipe(
      switchMap((subscription: RecipeSubscription) => {

        if (subscription.recipeSubscriptionDeliveries && subscription.recipeSubscriptionDeliveries.length > 0) {
          subscription.recipeSubscriptionDeliveries.forEach((val) => {
            if (val.deliverydate) {
              val.deliverydate = formatDate(val.deliverydate, 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);
            }
            if (val.alternatedeliverydate) {
              val.alternatedeliverydate = formatDate(val.alternatedeliverydate, 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);
              // MAG NIET https://ekomenu.atlassian.net/browse/EK-570 -> is achterhaald 15-3-2023
              //val.alternatedeliverydate = undefined;
            }
            if (val.recipeSubscriptionProductSelections) {
              val.recipeSubscriptionProductSelections = val.recipeSubscriptionProductSelections.filter(p => !p.couponcodeitem)
            }
          });
        }
        if (subscription.terminationdate)
          subscription.terminationdate = formatDate(subscription.terminationdate, 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);
        if (subscription.startdate)
          subscription.startdate = formatDate(subscription.startdate, 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);
        if (subscription.calculatednextdeliverydate)
          subscription.calculatednextdeliverydate = formatDate(subscription.calculatednextdeliverydate, 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);
        if(!subscription.storedata)
          subscription.storedata = "" //is required, cannot be null

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };
        const body = JSON.stringify(subscription);

        if (subscription.id > 0) {
          return this._http.put<RecipeSubscription>(environment.apiserver + 'recipesubscriptionbff/v1/recipesubscription/' + subscription.id, body, options).pipe(
            map((response: RecipeSubscription) => {
              //sorts all products by id desc
              response.recipeSubscriptionDeliveries.forEach(del => {
                del.recipeSubscriptionProductSelections.sort((a, b) => { return b.id - a.id })
              })

              this.recipesubscriptions[this.recipesubscriptions.map(r => r.id).indexOf(response.id)] = response;
              this.recipesubscriptionSubject.next(this.recipesubscriptions);
              this.updateSubscription(response, Originentitytype.RECIPE_SUBSCRIPTION)

              this._toastService.openWithTranslate('common.saved', null, {panelClass: null, duration: 2000})
              return response;  
            })
            , catchError(error => this.handleError(error, 'subscription.save_error'))
          );
        } else {
          return this._http.post<RecipeSubscription>(environment.apiserver + 'recipesubscriptionbff/v1/recipesubscription', body, options).pipe(
            map((response: RecipeSubscription) => {
              //sorts all deliveryproducts by id desc
              response.recipeSubscriptionDeliveries.forEach(del => {
                del.recipeSubscriptionProductSelections.sort((a, b) => { return b.id - a.id })
              })
              this.recipesubscriptions.push(response);
              this.recipesubscriptionSubject.next(this.recipesubscriptions);
              this.loadSubscriptions([response], Originentitytype.RECIPE_SUBSCRIPTION);

              return response;
            })
            , catchError(error => this.handleError(error, 'subscription.save_error'))
          );
        }
      }));
  }

  getCustomerBoxSubscriptionList(customerid: number): Observable<BoxSubscription[]> {
    if (!customerid) return of([])

    return this._http.get<BoxSubscription[]>(environment.apiserver + 'boxsubscriptionbff/v1/boxsubscription/customerid/' + customerid).pipe(
      map((response: BoxSubscription[]) => {
        this.boxsubscriptionsError.next(false);
        response = response.sort((a, b) => a.id - b.id)

        response.forEach(rec => {
          rec.boxSubscriptionDeliveries.forEach(del => {
            del.boxSubscriptionProductSelections.sort((a, b) => { return b.id - a.id })
          })
        })
        this.loadSubscriptions(response, Originentitytype.BOX_SUBSCRIPTION);

        this.boxsubscriptions = response;
        this.boxsubscriptionSubject.next(response);
        this.resetTimer();

        return response
      })
      , catchError(error => {
        this.boxsubscriptionsError.next(true)
        return this.handleError(error, 'subscription.get_subscriptionlist_error')
      })
    );
  }
  getCustomerBoxSubscription(subscriptionid: number): Observable<BoxSubscription> {
    /*return throwError(() => 'Server error');*/

    return this._http.get<BoxSubscription>(environment.apiserver + 'boxsubscriptionbff/v1/boxsubscription/' + subscriptionid).pipe(
      map((response: BoxSubscription) => {
        return response;
      })
      , catchError(error => this.handleError(error, 'subscription.get_subscription_error'))
    );
  }
  private updateBoxSubscriptionWithLastdata(subscriptionForm: FormGroup, changedValues: any = null): Observable<BoxSubscription> {
    if (subscriptionForm.get('id').value > 0) {
      return this.getCustomerBoxSubscription(subscriptionForm.get('id').value).pipe(
        switchMap((res: BoxSubscription) => {
          if (!changedValues)
            changedValues = this._globalService.getDirtyValues(subscriptionForm);
          res = this._globalService.mergeDirtyValues(changedValues, res);
          return of(res);
        })
      );
    } else {
      return of(subscriptionForm.getRawValue());
    }
  }
  getCustomerBoxSubscriptionDeliverydatesBySubscriptionid(subscriptionid: number): Observable<Deliveryday[]> {
    return this._deliverydayService.getBoxSubscriptionDeliverydates(subscriptionid).pipe(
      map((response: Deliveryday[]) => <any>response),
      catchError(error => this.handleError(error, 'subscription.get_deliverydates_error'))
    );
  }
  saveBoxSubscription(subscriptionForm: FormGroup, changedValues: any = null): Observable<BoxSubscription> {

    return this.updateBoxSubscriptionWithLastdata(subscriptionForm, changedValues).pipe(
      switchMap((subscription: BoxSubscription) => {
        if (subscription.boxSubscriptionDeliveries && subscription.boxSubscriptionDeliveries.length > 0) {
          subscription.boxSubscriptionDeliveries.forEach((val) => {
            if (val.deliverydate) {
              val.deliverydate = formatDate(val.deliverydate, 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);
            }
            if (val.alternatedeliverydate) {
              val.alternatedeliverydate = formatDate(val.alternatedeliverydate, 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);
            }
          });
        }
        if (subscription.terminationdate)
          subscription.terminationdate = formatDate(subscription.terminationdate, 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);
        if (subscription.startdate)
          subscription.startdate = formatDate(subscription.startdate, 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);
        if (subscription.calculatednextdeliverydate)
          subscription.calculatednextdeliverydate = formatDate(subscription.calculatednextdeliverydate, 'yyyy-MM-dd', ɵDEFAULT_LOCALE_ID);

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };
        const body = JSON.stringify(subscription);

        if (subscription.id > 0) {
          return this._http.put<BoxSubscription>(environment.apiserver + 'boxsubscriptionbff/v1/boxsubscription/' + subscription.id, body, options).pipe(
            map((response: BoxSubscription) => {

              response.boxSubscriptionDeliveries.forEach(del => {
                del.boxSubscriptionProductSelections.sort((a, b) => { return b.id - a.id })
              })

              this.boxsubscriptions[this.boxsubscriptions.map(r => r.id).indexOf(response.id)] = response;
              this.boxsubscriptionSubject.next(this.boxsubscriptions);
              this.loadSubscriptions([response], Originentitytype.BOX_SUBSCRIPTION);
              return response;
            })
            , catchError(error => this.handleError(error, 'subscription.save_error'))
          );
        } else {
          return this._http.post<BoxSubscription>(environment.apiserver + 'boxsubscriptionbff/v1/boxsubscription', body, options).pipe(
            map((response: BoxSubscription) => {

              response.boxSubscriptionDeliveries.forEach(del => {
                del.boxSubscriptionProductSelections.sort((a, b) => { return b.id - a.id })
              })
              this.boxsubscriptions.push(response);
              this.boxsubscriptionSubject.next(this.boxsubscriptions);
              this.loadSubscriptions([response], Originentitytype.BOX_SUBSCRIPTION);
              return response;
            })
            , catchError(error => this.handleError(error, 'subscription.save_error'))
          );
        }
      }));
  }

  get getSubscriptions(): FormArray {
    return this.subscriptions as FormArray;
  }
  originEntityType(subscription: FormGroup): Originentitytype {
    if (!subscription || !subscription.get('_originentitytype')) return null;
    return subscription.get('_originentitytype').value
  }
  private initiateSubscription(): FormGroup {
    const fg = new FormGroup({
      _originentitytype: new FormControl(null, Validators.required),
      id: new FormControl(null),
      enabled: new FormControl(true),
      brandid: new FormControl(environment.brandid, [Validators.required, Validators.min(1)]),
      customerid: new FormControl(null, [Validators.required, Validators.min(1)]),
      deliveryday: new FormControl(null, Validators.required),
      pickupdeliverytimeframe: new FormControl(null),
      storeid: new FormControl(null),
      storetype: new FormControl(null),
      storedata: new FormControl(''),
      shippingmethod: new FormControl(Shippingmethod.DOOR_DELIVERY, Validators.required),
      frequency: new FormControl(Frequency.EVERY_WEEK, Validators.required),
      defaultpersons: new FormControl(environment.personCountDefault, [Validators.required, Validators.min(1), Validators.max(4)]),
      defaultrecipes: new FormControl(environment.mealCountDefault, [Validators.min(1), Validators.max(4)]),
      persons: new FormControl(environment.personCountDefault, [Validators.min(1), Validators.max(4)]),

      deliveryinstructions: new FormControl(''),
      recipecard: new FormControl(false),
      alternateshippingaddress: new FormControl(null),
      alternatebillingaddress: new FormControl(null),
      startdate: new FormControl(null),
      activecouponcode: new FormControl(null),

      calculatednextdeliverydate: new FormControl(null),
      terminationdate: new FormControl(null),
      terminationcategory: new FormControl(null),
      terminationreason: new FormControl(null),

      recipeSubscriptionRepeatableproducts: new FormArray([]),
      recipeSubscriptionDeliveries: new FormArray([]),

      box: new FormControl(null, Validators.required),
      boxSubscriptionRepeatableproducts: new FormArray([]),
      boxSubscriptionDeliveries: new FormArray([]),

    });

    fg.get("_originentitytype").valueChanges.subscribe(res => {
      if (res === Originentitytype.RECIPE_SUBSCRIPTION) {
        fg.get('box').removeValidators(Validators.required);
        fg.get('box').updateValueAndValidity();
      }
    })

    return fg;
  }

  loadSubscriptions(subscriptions: any[], entitytype: Originentitytype) {
    if (entitytype === Originentitytype.RECIPE_SUBSCRIPTION) subscriptions as RecipeSubscription[];
    if (entitytype === Originentitytype.BOX_SUBSCRIPTION) subscriptions as BoxSubscription[];

    this._globalService.makeUnique(subscriptions).forEach(s => {

      const existingSubscription = this.getSubscriptions.controls.filter(ctrl => ctrl.get('_originentitytype').value == entitytype && ctrl.get('id').value === s.id)[0] as FormGroup;
      let fg = this.initiateSubscription();

      //updates if subscription already exists
      if (existingSubscription) {
        fg = existingSubscription;
      }

      let deliveries = [];
      let repeatableProducts = [];

      switch (entitytype) {
        case Originentitytype.RECIPE_SUBSCRIPTION:
          deliveries = s.recipeSubscriptionDeliveries;
          repeatableProducts = s.recipeSubscriptionRepeatableproducts
          break;
        case Originentitytype.BOX_SUBSCRIPTION:
          deliveries = s.boxSubscriptionDeliveries;
          repeatableProducts = s.boxSubscriptionRepeatableproducts
          break;
      }
      delete s.recipeSubscriptionDeliveries;
      delete s.recipeSubscriptionRepeatableproducts;
      delete s.boxSubscriptionDeliveries;
      delete s.boxSubscriptionRepeatableproducts;

      fg.patchValue(s);
      fg.get('_originentitytype').setValue(entitytype);

      deliveries.forEach(del => {
        if (!existingSubscription) {
          this.addDelivery(del, fg)
        } else {
          this.updateDelivery(del, fg)
        }
      });
      repeatableProducts.forEach(rep => {
        if (!existingSubscription) {
          this.addRepeatableProduct(rep, fg)
        } else {
          this.updateRepeatableProduct(rep, fg);
        }
      });

      this.setSubscriptionFieldsEnabledByOriginTypeAndSubscriptionEnabled(fg)

      if (!existingSubscription) {
        // fg.get('recipeSubscriptionDeliveries').valueChanges.subscribe(res=>{
        //   console.log('deliveries changed', res)
        // })

        fg.valueChanges.pipe(
          debounceTime(200),
          filter(() => fg.get('id').value > 0 && fg.dirty && fg.valid),
          switchMap(() => {
            switch (fg.get('_originentitytype').value) {
              case Originentitytype.RECIPE_SUBSCRIPTION:
                return this.saveRecipeSubscription(fg)
              case Originentitytype.BOX_SUBSCRIPTION:
                return this.saveBoxSubscription(fg);
            }
          })
        ).subscribe(result => {
          if (!result.enabled)
            fg.disable();
          this.updateSubscription(result, fg.get('_originentitytype').value)
        })

        this.getSubscriptions.push(fg);

      }
    })

    this.setCouponcodeOnFirstAvailableSubscription(this._couponcodeService.couponcode$.value?.code);
  }

  setSubscriptionFieldsEnabledByOriginTypeAndSubscriptionEnabled(sub: FormGroup) {
    if (sub.get('enabled').value === false) {
      sub.disable();
      return;
    }

    switch (sub.get('_originentitytype').value) {
      case Originentitytype.RECIPE_SUBSCRIPTION:
        sub.get('defaultrecipes').enable();
        sub.get('defaultpersons').enable();

        sub.get('box').disable();
        sub.get('box').clearValidators();
        sub.get('persons').disable();
        sub.get('persons').clearValidators();

        break;
      case Originentitytype.BOX_SUBSCRIPTION:
        sub.get('box').enable();
        sub.get('persons').enable();

        sub.get('defaultrecipes').disable();
        sub.get('defaultrecipes').clearValidators();
        sub.get('defaultpersons').disable();
        sub.get('defaultpersons').clearValidators();
        sub.get('box').setValidators(Validators.required);
        break;
    }
  }

  updateSubscription(subscription: any, entitytype: Originentitytype) {
    let sub = this.getSubscriptions.controls.find((ctrl: FormGroup) => ctrl.get('id').value === subscription.id && this.originEntityType(ctrl) === entitytype) as FormGroup
    if (!sub)
      sub = this.getSubscriptions.controls.find((ctrl: FormGroup) => ctrl.get('id').value === null && this.originEntityType(ctrl) === entitytype) as FormGroup

    if (!sub) {
      console.error('requested subscription cant be found in the list of subscriptions', subscription.id)
      return;
    }
    sub.markAsPristine();

    if (entitytype === Originentitytype.RECIPE_SUBSCRIPTION) {
      this.removeNotExistingDeliveries(subscription.recipeSubscriptionDeliveries, sub)
      subscription.recipeSubscriptionDeliveries.forEach(del => {
        this.updateDelivery(del, sub)
      })
      subscription.recipeSubscriptionRepeatableproducts.forEach(rep => {
        this.updateRepeatableProduct(rep, sub)
      })
    }

    if (entitytype === Originentitytype.BOX_SUBSCRIPTION) {

      this.removeNotExistingDeliveries(subscription.boxSubscriptionDeliveries, sub)
      subscription.boxSubscriptionDeliveries.forEach(del => {
        this.updateDelivery(del, sub)
      })
      subscription.boxSubscriptionDeliveries.forEach(rep => {
        this.updateRepeatableProduct(rep, sub)
      })
    }
  }

  updateRecipeDeliveryPrices(subscription: FormGroup, originalDeliverydate: any): Observable<RecipeSubscription> {
    return this._pricingService.getRecipesubscriptionprice(
      subscription.getRawValue() as unknown as RecipeSubscription,
      originalDeliverydate
      // this.activedelivery.deliveryday.originaldate ? this.activedelivery.deliveryday.originaldate : this.activedelivery.deliveryday.date,
    ).pipe(
      switchMap((result: RecipeSubscription) => {
        // this.error_calculateprices = false
        if (!result) { return; }

        // updates the repeatable products
        this.getRepeatableproducts(subscription).controls.forEach(ctrl => {
          const sku = ctrl.get('sku').value;
          const boxid = ctrl.get('boxid').value;
          const repeatableProduct = result.recipeSubscriptionRepeatableproducts.find(r => boxid ? r.boxid === boxid : r.sku === sku);
          if (repeatableProduct)
            ctrl.get('calculatedPrice').setValue(repeatableProduct['calculatedPrice'], { emitEvent: false });
        });

        const deliveryPrice = result.recipeSubscriptionDeliveries[0]
        const deliveryCtrl = this.getDeliveries(subscription).controls.find(ctrl => ctrl.get('deliverydate').value === deliveryPrice.deliverydate)
        if (!deliveryCtrl) return;

        // updates recipes
        if (deliveryPrice.recipeSubscriptionRecipeSelections) {
          this.getRecipeselections(deliveryCtrl).controls.forEach(recCtrl => {

            const recid = recCtrl.get('recipeid').value;
            const rec = deliveryPrice.recipeSubscriptionRecipeSelections.find(r => r.recipeid === recid);
            if (rec)
              recCtrl.get('calculatedPrice').setValue(rec.calculatedPrice, { emitEvent: false });
          });
        }
        // updates products
        if (deliveryPrice.recipeSubscriptionProductSelections) {

          this.getProductselections(deliveryCtrl).controls.forEach((prdCtrl, index) => {
            if (prdCtrl.get('couponcodeitem').value) {
              this.getProductselections(deliveryCtrl).removeAt(index)
            }
            const sku = prdCtrl.get('sku').value;
            const boxid = prdCtrl.get('boxid').value;
            const prd = deliveryPrice.recipeSubscriptionProductSelections.find(r => (r.boxid ? r.boxid === boxid : true) && (r.sku ? r.sku === sku : true));
            if (prd)
              prdCtrl.get('calculatedPrice').setValue(prd.calculatedPrice, { emitEvent: false });
          });

          //readds all couponcodeitems at the end
          if (deliveryPrice.recipeSubscriptionProductSelections.filter(f => f.couponcodeitem).length > 0) {
            deliveryPrice.recipeSubscriptionProductSelections.filter(f => f.couponcodeitem).forEach(couponcodeitem => {
              this.addProductSelection(couponcodeitem, deliveryCtrl as FormGroup)
            })
          }
        }


        const productCtrls = this.getProductselections(deliveryCtrl)
        //removes all recipecards when it is not returned
        if (productCtrls.controls.filter(p => p.value.recipecard).length > 0 && deliveryPrice.recipeSubscriptionProductSelections.filter(p => p.recipecard).length === 0) {
          do {
            const index = productCtrls.controls.findIndex(p => !p.value.boxid && (!p.value.sku || p.value.sku == ''))
            productCtrls.removeAt(index, { emitEvent: false });
          } while (productCtrls.controls.filter(p => !p.value.boxid && (!p.value.sku || p.value.sku == '')).length > 0)
        }
        // removes all changable data to not make it lag behind
        delete deliveryPrice.recipeSubscriptionRecipeSelections;
        delete deliveryPrice.recipeSubscriptionProductSelections;
        delete deliveryPrice.ispauzed;

        deliveryCtrl.patchValue(deliveryPrice, { emitEvent: false });
        return of(result);
      }),
      catchError(error => this.handleError(error))


    )
  }

  updateBoxDeliveryPrices(subscription: FormGroup, originalDeliverydate: any): Observable<BoxSubscription> {
    return this._pricingService.getBoxsubscriptionprice(
      subscription.getRawValue() as unknown as BoxSubscription,
      originalDeliverydate
      //this.activedelivery.deliveryday.originaldate ? this.activedelivery.deliveryday.originaldate : this.activedelivery.deliveryday.date,
    ).pipe(
      switchMap((result: BoxSubscription) => {
        // this.error_calculateprices = false
        if (!result) { return; }


        // updates the repeatable products
        this.getRepeatableproducts(subscription).controls.forEach(ctrl => {
          const sku = ctrl.get('sku').value;
          const boxid = ctrl.get('boxid').value;
          const rep = result.boxSubscriptionRepeatableproducts.filter(r => boxid ? r.boxid === boxid : r.sku === sku)[0];
          if (rep) {
            ctrl.get('calculatedPrice').setValue(rep['calculatedPrice'], { emitEvent: false });
          }
        });

        const deliveryPrice = result.boxSubscriptionDeliveries[0]
        const deliveryCtrl = this.getDeliveries(subscription).controls.find(ctrl => ctrl.get('deliverydate').value === deliveryPrice.deliverydate)
        if (!deliveryCtrl) return;

        if (deliveryPrice.boxSubscriptionProductSelections) {
          this.getProductselections(deliveryCtrl).controls.forEach(prdCtrl => {
            const sku = prdCtrl.get('sku').value;
            const boxid = prdCtrl.get('boxid').value;
            const prd = deliveryPrice.boxSubscriptionProductSelections.find(r => boxid ? r.boxid === boxid : r.sku === sku);
            if (prd)
              prdCtrl.get('calculatedPrice').setValue(prd.calculatedPrice, { emitEvent: false });
          });
        }
        // removes all changable data to not make it lag behind
        delete deliveryPrice.boxSubscriptionProductSelections;
        delete deliveryPrice.ispauzed;

        deliveryCtrl.patchValue(deliveryPrice, { emitEvent: false });
        return of(result);
      }),
      catchError(error => this.handleError(error))
    )
  }

  //should be private, but is not bc of tests
  setCouponcodeOnFirstAvailableSubscription(couponcodecode: string) {
    //only do anything if there is a couponcode
    if (!couponcodecode) return;

    this.getSubscriptions.controls.forEach(async s => {
      //only do anything when the subscription is active
      if (!s.get('enabled').value) return
      //checks if the current couponcode is still valid
      if (s.get('activecouponcode').value) {

        this._couponcodeService.checkCouponcode(s.get('activecouponcode').value, s.get('customerid').value, this._customerService.customer?.email, s.get('_originentitytype').value, false).subscribe(activecouponcodevalid => {
          if (activecouponcodevalid) {
            this._toastService.openWithTranslate('couponcode.subscription_couponcode_still_active', 'common.ok_dismiss', Snackbarformat);
            //it doesnt matter if the couponcode stays in the browser, the customer only gets a notification every time they refresh.... but it can be applicable to a single order
            this._couponcodeService.removeCouponcodeFromStorage();
            return;
          } else {
            this.tryApplyCouponcodeToSubscription(couponcodecode, s as FormGroup)
          }
        })
      } else {
        this.tryApplyCouponcodeToSubscription(couponcodecode, s as FormGroup)
      }
    })
  }

  tryApplyCouponcodeToSubscription(couponcodecode: string, s: FormGroup) {
    //checks if the new couponcode in this subscription is valid
    this._couponcodeService.checkCouponcode(couponcodecode, s.get('customerid').value, this._customerService.customer?.email, s.get('_originentitytype').value).subscribe(async newcouponcodevalid => {
      if (!newcouponcodevalid) {
        this._toastService.openWithTranslate('couponcode.couponcode_not_valid_with_this_subscription', 'common.ok_dismiss', Snackbarformat);
        //it doesnt matter if the couponcode stays in the browser, the customer only gets a notification every time they refresh.... but it can be applicable to a single order
        // this._couponcodeService.removeCouponcode(); 
        return;
      }
      //sets couponcode if it is valid and usable and saves the subscription
      s.get('activecouponcode').setValue(couponcodecode);
      s.get('activecouponcode').markAsDirty();
      this._couponcodeService.removeCouponcodeFromStorage()
      if (s.get('_originentitytype').value === Originentitytype.RECIPE_SUBSCRIPTION)
        await firstValueFrom(this.saveRecipeSubscription(s.getRawValue()))
      if (s.get('_originentitytype').value === Originentitytype.BOX_SUBSCRIPTION)
        await firstValueFrom(this.saveBoxSubscription(s.getRawValue()));
      this._toastService.openWithTranslate('couponcode.couponcode_added_to_subscription', 'common.ok_dismiss', Snackbarformat);
    })
  }

  getSubscriptionShippingCustomeraddress(subscription: RecipeSubscription | BoxSubscription): CustomerAddress {
    if (subscription.alternateshippingaddress)
      return this._customerService.getCustomerAddressById(subscription.alternateshippingaddress)
    return this._customerService.getCustomerAddressByAddressId(this._customerService.getCustomerDefaultShippingaddress()?.id)
  }

  getDeliveries(subscription): FormArray {
    if (this.originEntityType(subscription) === Originentitytype.RECIPE_SUBSCRIPTION)
      return subscription.get('recipeSubscriptionDeliveries') as FormArray;
    if (this.originEntityType(subscription) === Originentitytype.BOX_SUBSCRIPTION)
      return subscription.get('boxSubscriptionDeliveries') as FormArray
  }
  initiateDelivery(): FormGroup {
    const fgroup = this.fb.group({
      id: [null],
      deliverydate: ['', Validators.required],
      alternatedeliverydate: [null],
      alternateshippingaddress: [null],
      alternatebillingaddress: [null],
      couponcode: [null],
      pickupdeliverytimeframe: [null],
      storeid: [null],
      storetype: [null],
      storedata: [null],
      shippingmethod: [null],
      orderid: [null],
      reminderemailsent: [null],
      ispauzed: [null],
      recipeSubscriptionRecipeSelections: this.fb.array([]),
      recipeSubscriptionProductSelections: this.fb.array([]),
      boxSubscriptionProductSelections: this.fb.array([]),
      calculatedPrice: [null]
    });
    return fgroup;
  }
  createDelivery(originaldate: any, subscription: FormGroup): FormGroup {
    if (this.originEntityType(subscription) === Originentitytype.RECIPE_SUBSCRIPTION) {
      const delivery = new RecipeSubscriptionDelivery(null, originaldate, null, null, null, null, null, null, null, null, null, null, null, false, [], [], null);
      return this.addDelivery(delivery, subscription);
    } else {
      const delivery = new BoxSubscriptionDelivery(null, originaldate, null, null, null, null, null, null, null, null, null, null, null, false, [], null);
      return this.addDelivery(delivery, subscription);
    }
  }
  addDelivery(delivery: any, subscription: FormGroup): FormGroup { //(RecipeSubscriptionDelivery| BoxSubscriptionDelivery)

    if (this.getDeliveries(subscription).controls.map(ctrl => ctrl.value.deliverydate).includes(delivery.deliverydate)) {
      console.warn('This subscription already contains a delivery with deliverydate: ' + delivery.deliverydate)
    }

    const delForm = this.initiateDelivery()
    delForm.patchValue(delivery);
    // should always set the subscriptionform as the parent, thats whats expected in other places
    delForm.setParent(subscription);

    if (this.originEntityType(subscription) === Originentitytype.RECIPE_SUBSCRIPTION) {
      if (delivery.recipeSubscriptionRecipeSelections)
        delivery.recipeSubscriptionRecipeSelections.forEach(recipeSel => {
          this.addRecipeSelection(recipeSel, delForm)
        })
      if (delivery.recipeSubscriptionProductSelections)
        delivery.recipeSubscriptionProductSelections.forEach(productSel => {
          this.addProductSelection(productSel, delForm)
        })
    }
    if (this.originEntityType(subscription) === Originentitytype.BOX_SUBSCRIPTION) {
      if (delivery.boxSubscriptionProductSelections)
        delivery.boxSubscriptionProductSelections.forEach(productSel => {
          this.addProductSelection(productSel, delForm)
        })
    }

    this.getDeliveries(subscription).push(delForm)

    // should always set the subscriptionform as the parent, thats whats expected in other places
    delForm.setParent(subscription);

    if (!delivery.id) {
      delForm.markAsDirty();

      delForm.get('deliverydate').markAsDirty();

      delForm.get('recipeSubscriptionRecipeSelections').markAsDirty();
      delForm.get('recipeSubscriptionProductSelections').markAsDirty();

      delForm.get('recipeSubscriptionProductSelections').markAsDirty();

    }
    return delForm;
  }
  updateDelivery(del: any, subscription: FormGroup) {
    const deliveries = this.getDeliveries(subscription);
    let delivery = deliveries.controls.find(delCtrl => delCtrl.get('id').value === del.id)
    if (!delivery)
      delivery = deliveries.controls.find(delCtrl => delCtrl.get('id').value === null)

    if (!delivery) {
      delivery = this.addDelivery(del, subscription)
      // console.error('requested delivery cant be found in the list of subscriptions', del.id)
      // return;
    }

    if (this.originEntityType(subscription) === Originentitytype.RECIPE_SUBSCRIPTION) {
      if (del.recipeSubscriptionRecipeSelections)
        del.recipeSubscriptionRecipeSelections.forEach(rec => {
          this.updateRecipeselection(rec, delivery as FormGroup)
        })
      if (del.recipeSubscriptionProductSelections)
        del.recipeSubscriptionProductSelections.forEach(prod => {
          this.updateProductSelection(prod, delivery as FormGroup)
        })
      delete del.recipeSubscriptionRecipeSelections
      delete del.recipeSubscriptionProductSelections
    }

    if (this.originEntityType(subscription) === Originentitytype.BOX_SUBSCRIPTION) {
      if (del.recipeSubscriptionProductSelections)
        del.boxSubscriptionProductSelections.forEach(prod => {
          this.updateProductSelection(prod, delivery as FormGroup)
        })
      delete del.boxSubscriptionProductSelections
    }

    delivery.markAsPristine();
    delivery.patchValue(del)
  }
  removeNotExistingDeliveries(serverDeliveries: any[], subscription: FormGroup) { //RecipeSubscriptionDelivery[] | boxSubscriptionDelivery[]
    const deliveries = this.getDeliveries(subscription)

    const removedDeliveries = deliveries.controls.filter(ctrl => {
      const includes = !serverDeliveries.map(d => d.id).includes(ctrl.get('id').value);
      return includes
    })

    removedDeliveries.forEach(del => {
      const index = deliveries.controls.findIndex(delivery => delivery.value.id === del.value.id)
      deliveries.controls.splice(index, 1)
    })
  }

  getRepeatableproducts(subscription): FormArray {
    if (this.originEntityType(subscription) === Originentitytype.RECIPE_SUBSCRIPTION)
      return subscription.get('recipeSubscriptionRepeatableproducts') as FormArray
    if (this.originEntityType(subscription) === Originentitytype.BOX_SUBSCRIPTION)
      return subscription.get('boxSubscriptionRepeatableproducts') as FormArray
  }
  initiateRepeatableProduct(): FormGroup {
    const fgroup = this.fb.group({
      id: [null],
      sku: [null],
      product: [null],
      boxid: [null],
      box: [null],
      persons: [0],
      quantity: [null, Validators.required],
      calculatedPrice: [null]
    });
    return fgroup;
  }
  addRepeatableProduct(repeatable: SubscriptionRepeatableproduct, subscription: FormGroup) {
    const sel = this.initiateRepeatableProduct();
    sel.patchValue(repeatable);
    this.getRepeatableproducts(subscription).push(sel);
    if (repeatable.sku) {
      this._productService.getProductBySKU(repeatable.sku).subscribe((value: Product) => {
        sel.get('product').setValue(value)
      })
    }
    if (repeatable.boxid) {
      this._boxService.getBox(repeatable.boxid).subscribe((value: Box) => {
        sel.get('box').setValue(value)
      })
    }
  }
  updateRepeatableProduct(repeatable: any, subscription: FormGroup) {
    const repeatableProducts = this.getRepeatableproducts(subscription)
    let product = repeatableProducts.controls.find(selCtrl => selCtrl.get('id').value === repeatable.id)
    if (!product)
      product = repeatableProducts.controls.find(selCtrl => selCtrl.get('id').value === null)

    if (!product) {
      this.addRepeatableProduct(repeatable, subscription)
      //console.error('requested recipeselection cant be found in the list of recipeselections', recipeselection.id)
      return;
    }
    product.patchValue(repeatable)
  }

  initiateRecipeselection(): FormGroup {
    const fgroup = this.fb.group({
      id: [null],
      recipeid: [null],
      recipe: [null],
      persons: [null],
      quantity: [null],
      couponcodeitem: [false],
      calculatedPrice: [null]
    });
    return fgroup;
  }
  getRecipeselections(delivery): FormArray {
    return delivery.get('recipeSubscriptionRecipeSelections') as FormArray
  }
  addRecipeSelection(selection: RecipeSubscriptionRecipeSelection, delivery: FormGroup): boolean {
    if (this.getRecipeselections(delivery).value.map(m => m.recipeid).includes(selection.recipeid)) return;

    //checks if there arent already 9 recipes added EK-1331
    if (!selection.couponcodeitem) {
      const recipescount = this.getRecipeselections(delivery).value.filter((line: RecipeSubscriptionRecipeSelection) => line.recipeid && !line.couponcodeitem).length;
      if (recipescount >= environment.maxRecipeQuantity) {
        this._toastService.openWithTranslate('validation.max_number_of_dishes', 'common.ok_dismiss', Snackbarerrorformat)
        return false;
      }
    }

    const sel = this.initiateRecipeselection();
    sel.patchValue(selection);
    this.getRecipeselections(delivery).push(sel);
    if (selection.recipeid) {
      this._recipeService.getRecipe(selection.recipeid).subscribe((value: Recipe) => {
        sel.get('recipe').setValue(value)
      })
    }
    return true;
  }
  removeRecipeSelection(index: number, delivery: FormGroup) {
    this.getRecipeselections(delivery).removeAt(index)
  }
  updateRecipeselection(recipeselection: RecipeSubscriptionRecipeSelection, delivery: FormGroup) {
    const selections = this.getRecipeselections(delivery);
    let selection = selections.controls.find(selCtrl => selCtrl.get('id').value === recipeselection.id)
    if (!selection)
      selection = selections.controls.find(selCtrl => selCtrl.get('id').value === null)

    if (!selection) {
      this.addRecipeSelection(recipeselection, delivery)
      //console.error('requested recipeselection cant be found in the list of recipeselections', recipeselection.id)
      return;
    }
    selection.patchValue(recipeselection)
  }

  getProductselections(delivery): FormArray {
    if (this.originEntityType(delivery.parent as FormGroup) === Originentitytype.RECIPE_SUBSCRIPTION)
      return delivery.get('recipeSubscriptionProductSelections') as FormArray
    if (this.originEntityType(delivery.parent as FormGroup) === Originentitytype.BOX_SUBSCRIPTION)
      return delivery.get('boxSubscriptionProductSelections') as FormArray
  }
  initiateProductelection(): FormGroup {
    const fgroup = this.fb.group({
      id: [null],
      boxid: [null],
      box: [null],
      persons: [null],
      sku: [null],
      product: [null],
      quantity: [null],
      couponcodeitem: [false],
      compensationitem: [false],
      recipecard: [false],
      calculatedPrice: [null]
    });
    return fgroup;
  }
  addProductSelection(selection: SubscriptionProductSelection, delivery: FormGroup) {
    const sel = this.initiateProductelection();
    sel.patchValue(selection);
    this.getProductselections(delivery).push(sel);
    if (selection.sku) {
      this._productService.getProductBySKU(selection.sku).subscribe((value: Product) => {
        sel.get('product').setValue(value, { emitEvent: !selection.couponcodeitem })
      })
    }
    if (selection.boxid) {
      this._boxService.getBox(selection.boxid).subscribe((value: Box) => {
        sel.get('box').setValue(value, { emitEvent: !selection.couponcodeitem })
      })
    }
  }
  updateProductSelection(productselection: SubscriptionProductSelection, delivery: FormGroup) {
    const selections = this.getProductselections(delivery);
    let selection = selections.controls.find(selCtrl => selCtrl.get('id').value === productselection.id)
    if (!selection)
      selection = selections.controls.find(selCtrl => selCtrl.get('id').value === null)

    if (!selection) {
      this.addProductSelection(productselection, delivery)
      // console.error('requested productselection cant be found in the list of productselections', productselection.id)
      return;
    }
    selection.patchValue(productselection)
  }
  private handleError(error: Response, msgText: string = null) {
    if (msgText)
      this._toastService.openWithTranslate(msgText, null, Snackbarerrorformat)

    if (error.status === 400) {
      return throwError(() => 'Bad request');
    }
    return throwError(() => error || 'Server error');

  }
}
